import { NavigationItem } from "./navigation.types";

export const navigations: NavigationItem[] = [
    {
        id: 'home',
        title: 'Accueil',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/home',
        authorized: ['User', 'Admin']
    },
    // {
    //     id: 'home',
    //     title: 'Accueil',
    //     type: 'basic',
    //     icon: 'heroicons_outline:home',
    //     link: '/admin-home',
    //     authorized: ['Admin']
    // },
    // {
    //     id: 'dashboard',
    //     title: 'Tableaux de bord',
    //     type: 'basic',
    //     icon: 'heroicons_outline:presentation-chart-line',
    //     link: '/data-management/dashboards',
    //     authorized: ['User']
    // },
    // {
    //     id: 'docs',
    //     title: 'Rapports et documents',
    //     type: 'basic',
    //     icon: 'heroicons_outline:document-text',
    //     link: '/data-management/docs',
    //     authorized: ['User']
    // },
    // {
    //     id: 'playground',
    //     title: 'OLAP Playground',
    //     type: 'basic',
    //     icon: 'feather:airplay',
    //     link: '/playground'
    // },
    {
        id: 'data-settings',
        title: 'Paramètres de données',
        type: 'aside',
        icon: 'heroicons_outline:cog-6-tooth', authorized: ['Admin'],
        children: [
            {
                id: 'separtor',
                type: 'divider',
                // classes: { wrapper: 'md:mt-[160px]' }
            },
            {
                id: 'sectors',
                title: 'Secteurs',
                type: 'basic',
                icon: 'heroicons_outline:chart-pie',
                link: '/data-settings/sectors'
            },
            {
                id: 'subsectors',
                title: 'Sous-secteurs',
                type: 'basic',
                icon: 'heroicons_outline:chart-pie',
                link: '/data-settings/subsectors'
            },
            {
                id: 'thematics',
                title: 'Thématiques',
                type: 'basic',
                icon: 'heroicons_outline:square-3-stack-3d',
                link: '/data-settings/thematics'
            },
            {
                id: 'separator',
                type: 'divider'
            },
            {
                id: 'models',
                title: 'Modélisation',
                type: 'basic',
                icon: 'heroicons_outline:squares-2x2',
                link: '/data-settings/models'
            }
        ]
    },
    {
        id: 'data-management',
        title: 'Gestion des données',
        type: 'aside',
        icon: 'feather:database',
        authorized: ['Admin'],
        children: [
            {
                id: 'separator',
                type: 'divider',
                // classes: { wrapper: 'md:mx-auto' }
            },
            {
                id: 'ingestions',
                title: 'Importation des données',
                type: 'basic',
                icon: 'heroicons_outline:cloud-arrow-up',
                link: '/data-management/ingestions'
            },
            {
                id: 'ingestions-validation',
                title: 'Validation de l\'importation des données',
                type: 'basic',
                icon: 'heroicons_outline:check-badge',
                link: '/data-management/ingestions-validation'
            },
            {
                id: 'separator',
                type: 'divider'
            },
            {
                id: 'data-sets',
                title: 'Jeux de données',
                type: 'basic',
                icon: 'feather:database',
                link: '/data-management/datasets'
            },
            {
                id: 'data-playground',
                title: 'OLAP Playground',
                type: 'basic',
                icon: 'feather:airplay',
                link: '/data-management/playground'
            },
            // {
            //     id: 'documents',
            //     title: 'Documents',
            //     type: 'basic',
            //     icon: 'heroicons_outline:document-duplicate',
            //     link: '/data-management/docs'
            // },
        ]
    },
    {
        id: 'dashboard',
        title: 'Tableaux de bord',
        type: 'basic',
        icon: 'heroicons_outline:presentation-chart-line',
        link: '/data-management/dashboards',
        authorized: ['Admin', 'User'],
        // children: [
        //     {
        //         id: 'separator',
        //         type: 'divider',
        //         // classes: { wrapper: 'md:mt-[344px]' }
        //     },
        //     {
        //         id: 'dashboards',
        //         title: 'Créer un tableau de bord',
        //         type: 'basic',
        //         icon: 'heroicons_outline:plus',
        //         link: '/data-management/dashboard-builder'
        //     },
        //     {
        //         id: 'dashboard-list',
        //         title: 'Tableaux de bord',
        //         type: 'basic',
        //         icon: 'heroicons_outline:presentation-chart-line',
        //         link: '/data-management/dashboards'
        //     },
        //     {
        //         id: 'separtor',
        //         type: 'divider'
        //     },
        // ],
    },
    {
        id: 'documents',
        title: 'Documents',
        type: 'basic',
        icon: 'heroicons_outline:document-duplicate',
        link: '/data-management/documents',
        authorized: ['Admin', 'User']
    },
    {
        id: 'graphics',
        title: 'Graphiques',
        type: 'basic',
        icon: 'heroicons_outline:chart-bar-square',
        link: '/data-management/graphic-templates',
        authorized: ['Admin', 'User']
    },
    {
        id: 'parameters',
        title: 'Paramètres',
        type: 'aside',
        icon: 'heroicons_outline:wrench-screwdriver',
        authorized: ['Admin'],
        children: [
            {
                id: 'companies',
                title: 'Compagnies',
                type: 'basic',
                icon: 'heroicons_outline:building-office-2',
                // classes: { wrapper: 'md:mt-[426px]' },
                link: '/user-management/companies'
            },
            {
                id: 'users',
                title: 'Utilisateurs',
                type: 'basic',
                icon: 'heroicons_outline:user',
                link: '/user-management/users'
            },
            {
                id: 'subscriptions',
                title: 'Abonnements',
                type: 'basic',
                icon: 'heroicons_outline:inbox-arrow-down',
                link: '/subscriptions'
            },
            {
                id: 'separtor',
                type: 'divider'
            },
            {
                id: 'localities',
                title: 'Pays et localités',
                type: 'basic',
                icon: 'heroicons_outline:map-pin',
                // classes: { wrapper: 'md:mt-[344px]' },
                link: '/parameters/localities'
            },
            {
                id: 'domains',
                title: 'Domaines d\'activités',
                type: 'basic',
                icon: 'heroicons_outline:rectangle-group',
                link: '/parameters/company-domains'
            },
            {
                id: 'separtor',
                type: 'divider'
            },
            {
                id: 'tasks-manager',
                title: 'Gestion des tâches',
                type: 'basic',
                icon: 'heroicons_outline:cog-6-tooth',
                link: '/parameters/tasks-manager'
            },
            {
                id: 'cube-manager',
                title: 'Gestion des cubes',
                type: 'basic',
                icon: 'heroicons_outline:cube',
                link: '/parameters/cube-manager'
            },
            {
                id: 'druid-manager',
                title: 'Gestion Druid',
                type: 'basic',
                icon: 'heroicons_outline:server-stack',
                link: '/parameters/druid-manager'
            }
        ]
    },
    // {
    //     id: 'users',
    //     title: 'Gestion des utilisateurs',
    //     type: 'aside',
    //     icon: 'heroicons_outline:users',
    //     authorized: ['Admin'],
    //     children: [
    //         // {
    //         //     id: 'admins',
    //         //     title: 'Adminstrateurs',
    //         //     type: 'basic',
    //         //     icon: 'heroicons_outline:shield-check',
    //         //     link: '/user-management/roles'
    //         // }
    //     ]
    // },
];